import ModalContent from "./ModalContent.jsx"

export default ModalContent;